import useContextWithErrorHandler from '@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { LanguageContext, UseLanguage } from '../providers/LanguageProvider';

const useLanguage = (): UseLanguage => {
  const [state, dispatch] = useContextWithErrorHandler<UseLanguage>(
    LanguageContext,
    'LanguageProvider'
  );

  return [state, dispatch];
};

export default useLanguage;
